import Resizeable from './Resizeable';
export default Resizeable;
